module.exports = __webpack_public_path__ + "img/navy-gold-med.9ea35c75.png";